import { Box, styled, Typography, TypographyProps } from '@mui/material'

export const PrivacyPolicyContainer = styled(Box)(() => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
}))

export const PrivacyPolicyTitle = styled((props) => (
  <Typography component="h1" {...props} />
))<TypographyProps>(({ theme }) => ({
  ...theme.typography.h2,
  marginBottom: theme.spacing(17),
  marginTop: theme.spacing(2),
  [theme.breakpoints.up('md')]: {
    ...theme.typography.h1,
  },
}))

export const PrivacyPolicyItemTitle = styled(Typography)(({ theme }) => ({
  ...theme.typography.h4,
  marginBottom: theme.spacing(3),
  [theme.breakpoints.up('md')]: {
    ...theme.typography.h3,
  },
})) as typeof Typography

export const PrivacyPolicyItemText = styled(Typography)(({ theme }) => ({
  ...theme.typography.body1,
}))

export const PrivacyPolicyItem = styled(Box)(({ theme }) => ({
  alignSelf: 'flex-start',
  '&:not(:last-child)': {
    marginBottom: theme.spacing(8),
  },
}))
